<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'pages.bulkNumberInformation.importfromfile.title'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
    [showRefreshBtn]="false"
  >
    <div class="card-toolbar" before-btns>
      <!-- download sample btn -->
      <a
        href="/assets/media/sample/importUsers.xlsx"
        class="btn txt-lg button-shadow tw-mx-1 btn-hover-rise"
        [themeColor]="'btn'"
        type="button"
        mat-ripple
        [matTooltip]="'pages.users.importfromfile.downloadSample' | translate"
      >
        <span>{{
          "pages.users.importfromfile.downloadSample" | translate
        }}</span>
        <i class="mdi mdi-download mdi-20px tw-p-0 text-white"></i>
      </a>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <form autocomplete="off" [formGroup]="form">
      <fieldset>
        <div class="row tw-px-4">
          <!-- alert -->
          <div
            class="alert tw-bg-gray-50 dark:tw-bg-dark-200 dark:tw-text-gray-300 border tw-mb-4 tw-mt-1 md:tw-w-full"
          >
            <details
              #uploadFileAlertDetails
              (click)="onChangeAlertDetailsInUploadMode(uploadFileAlertDetails)"
              open
            >
              <summary class="tw-font-semibold text-navyBlue">
                {{ "common.help" | translate }}
                <span *ngIf="!isShowAlertDetailsInUploadMode">
                  ( {{ "common.clickForMoreInfo" | translate }})
                </span>
              </summary>
              <div
                [innerHTML]="
                  'pages.users.importfromfile.uploadAddDescription'
                    | translate : { fileType: 'xlsx' }
                "
              ></div>
            </details>
          </div>

          <!-- organizationId -->
          <div class="md:tw-w-1/2">
            <organization-select-search
              class="tw-w-full"
              [type]="
                userType == 'reseller'
                  ? 'currentResellerOrganization'
                  : 'organizationForCreateUser'
              "
              [control]="form?.get('organizationId')"
              (valueChange)="model.organizationId = $event"
              (onError)="onClose()"
            >
            </organization-select-search>
          </div>

          <div class="md:tw-w-1/2">
            <file-uploader
              [label]="fields + 'selectfile'"
              [control]="form?.get('inputFile')"
              class="tw-w-[275px]"
              (valueChange)="readFileAndCreateInMemoryData($event)"
              acceptFile=".xls,.xlsx,.csv"
              [maxFileSize]="100"
              sizeType="mb"
              (onErrorFile)="showErrorDialog($event)"
            >
            </file-uploader>
          </div>
        </div>

        <div class="row">
          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'isForeigner'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('isForeigner')"
            [removable]="false"
            [(value)]="isForeigner"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'firstName'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('firstName')"
            [removable]="false"
            [(value)]="firstName"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'lastName'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('lastName')"
            [removable]="false"
            [(value)]="lastName"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'fatherName'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('fatherName')"
            [removable]="false"
            [(value)]="fatherName"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'birthDate'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('birthDate')"
            [removable]="false"
            [(value)]="birthDate"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'nationalCode'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('nationalCode')"
            [removable]="false"
            [(value)]="nationalCode"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'identityNumber'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('identityNumber')"
            [removable]="false"
            [(value)]="identityNumber"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'phone'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('phone')"
            [removable]="false"
            [(value)]="phone"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'faxNumber'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('faxNumber')"
            [removable]="false"
            [(value)]="faxNumber"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'mobile'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('mobile')"
            [removable]="false"
            [(value)]="mobile"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'zoneId'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('zoneName')"
            [removable]="false"
            [(value)]="zoneName"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'zipCode'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('zipCode')"
            [removable]="false"
            [(value)]="zipCode"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'address'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('address')"
            [removable]="false"
            [(value)]="address"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'userName'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('userName')"
            [removable]="false"
            [(value)]="userName"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'password'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('password')"
            [removable]="false"
            [(value)]="password"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'email'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('email')"
            [removable]="false"
            [(value)]="email"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'expireDate'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('expireDate')"
            [removable]="false"
            [(value)]="expireDate"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'descriptions'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('descriptions')"
            [removable]="false"
            [(value)]="descriptions"
          >
          </custom-select-search>

          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'isActiveSend'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('isActiveSend')"
            [removable]="false"
            [(value)]="isActiveSend"
          >
          </custom-select-search>
          <custom-select-search
            *ngIf="!this.loading && this.jsonData != null"
            class="md:tw-w-1/2"
            [label]="fields + 'isActive'"
            [items]="importedColList"
            optionTitle="value"
            optionValue="value"
            [control]="form?.get('isActive')"
            [removable]="false"
            [(value)]="isActive"
          >
          </custom-select-search>
        </div>
      </fieldset>

      <section class="tw-mt-4">
        <fieldset>
          <legend>
            {{ "common.roles" | translate }}
          </legend>

          <div class="row">
            <role-selection-list
              [class.d-none]="!model.organizationId"
              type="organizationRoles"
              [id]="model.organizationId"
              searchLabel="messages.searchInRoles"
              [values]="model.roleIds"
              (values)="model.roleIds = $event"
            >
            </role-selection-list>

            <p
              [class.d-none]="model.organizationId"
              class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-lg tw-my-3"
            >
              {{ "messages.selectOrganizationForRoles" | translate }}
            </p>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="false"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
